up.compiler('.js-unread_messages_counter_wrapper', async function (wrapper) {
  const { createVueApp } = await import(/* webpackChunkName: "create_vue_app" */ '../create_vue_app')
  const { default: UnreadMessagesCounter } = await import(
    /* webpackChunkName: "unread_messages_counter" */ './UnreadMessagesCounter.vue'
  )
  const el = wrapper.querySelector('.js-unread_messages_counter')
  const app = createVueApp({
    components: { UnreadMessagesCounter }
  })

  app.mount(el)

  up.destructor(wrapper, () => {
    app.unmount()
  })
})
